import React from "react";
import { User } from "@common/types/user";
import styles from "./UserDropdownHeader.module.scss";

interface UserDropdownHeaderProps {
    user: User;
}

export const UserDropdownHeader: React.FC<UserDropdownHeaderProps> = ({
    user,
}) => (
    <div className={styles.userDropdownHeader}>
        <div
            className={styles.userDropdownUserName}
            data-testid="dropdown-user-name"
        >
            {user.name}
        </div>
        <div
            className={styles.userDropdownUserEmail}
            data-testid="dropdown-user-email"
        >
            {user.email}
        </div>
    </div>
);
